import intercom from '../../utils/intercom';

declare var angular

angular.module('wbDirectives').directive('wbIntercom', function() {
  return {
    restrict: 'A',
    link: function($scope, $el, $attrs: any) {
      let value = $attrs.wbIntercom || 'show'

      $el.on('click', function() {
        value.startsWith('show') ? intercom.show(value) : intercom.execute(value)
      })
    }
  }
})
